export default (state, action) => {
  return Object.assign({}, state, { show: action.show });
};
